// extracted by mini-css-extract-plugin
module.exports = {"container":"Attribution_container__EYoh_","imgWrapper":"Attribution_imgWrapper__a_U7b","text":"Attribution_text__KNIR_"};